import { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  ExpandableContent,
} from '@kanda-libs/ks-design-library';

import CompanyBanner from 'components/company/CompanyLayout/CompanyBanner';
import CompanyDetails from 'components/company/CompanyLayout/CompanyDetails';
import CompanyRates from 'components/company/CompanyLayout/CompanyRates';
import JobTable from 'components/job/JobTable';

import CompanyRateRequest from './CompanyRateRequest';
import useCompany from './useCompany';

const CompanyLayout: FunctionComponent = function ({}) {
  const { showRateRequest, ...company } = useCompany();
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <CompanyBanner />
        {showRateRequest ? (
          <ExpandableContent
            showLabel="Show rate request"
            hideLabel="Hide rate request"
          >
            <CompanyRateRequest />
          </ExpandableContent>
        ) : (
          <div />
        )}
        <ExpandableContent
          showLabel="Show company details"
          hideLabel="Hide company details"
        >
          <CompanyDetails />
          <CompanyRates />
        </ExpandableContent>
        <JobTable showHeader={false} {...company} />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default CompanyLayout;
